<template>
    <div class="detail">
        <div>
            <span class="subTitle"><s-l id="detail_SeasonTitleJoueur" :v="saison.joueurs.length">Nombre de joueurs : %v</s-l>
                 
             </span>
      
        </div>
        <div class='description'>
            <span class="subTitle"><s-l id="detail_SeasonTitleConcours" :v="saison.tournois.length">Nombre de concours : %v</s-l>  
             
            </span>
        </div>
    </div>
</template>
<style  scoped>
    .subTitle {
        font-size: 20px;
        font-weight: bolder;
    }
    .detail {
        padding: 10px; 
        color: black;
       
    }
    .description {
        color: black;
        
    }
</style>
<script >
export default {
    props: ["saison", "club"],
    methods: {
        getLabel(idLabel) {
            if (this.club)
                 return this.club.customs[idLabel].label;
        }
    }
}
</script>